<div class="d-flex flex-column align-items-center overflow-hidden">
    <adapt-see-more-popup [minWidth]="500"
                          popupTitle="Strategic themes"
                          buttonText="View strategic themes">
        <ng-template>
            <div class="w-100 d-flex align-items-end pb-3 mb-3 border-bottom">
                <adapt-strategic-guidance area="strategic themes"></adapt-strategic-guidance>
            </div>
            <ng-container *adaptIfAuthorised="ReadStrategyBoard; else featureNotEnabled">
                <adapt-strategy-board [isEditing]="true"
                                      [views]="mapViews"
                                      [showToolbarMenu]="false"></adapt-strategy-board>
                <button *adaptIfAuthorised="EditStrategyBoard"
                        adaptButton="primary"
                        class="mt-3"
                        [adaptBlockingClick]="addTheme">Add theme</button>
            </ng-container>

            <ng-template #featureNotEnabled>
                <span>This feature is enabled only for the Scale+ platform subscription.</span>
            </ng-template>
        </ng-template>
    </adapt-see-more-popup>
</div>
